import { authHeader, handleUnauthorized, captureRefreshedToken } from './authToken';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const checarResposta = async (response, mensagemErro) => {
  captureRefreshedToken(response.headers);
  if (response.status === 401) {
    handleUnauthorized();
  }
  if (!response.ok) throw new Error(mensagemErro);
  return response.json();
};

export const TabelasPesoService = {
  async listar() {
    const response = await fetch(`${API_URL}/tabelas-peso`, { headers: { ...authHeader() } });
    return checarResposta(response, 'Erro ao buscar tabelas de peso');
  },

  async buscarPorId(id) {
    const response = await fetch(`${API_URL}/tabelas-peso/${id}`, { headers: { ...authHeader() } });
    return checarResposta(response, 'Erro ao buscar tabela');
  },

  async criar(dados) {
    const response = await fetch(`${API_URL}/tabelas-peso`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(dados)
    });
    return checarResposta(response, 'Erro ao salvar tabela');
  },

  async atualizar(id, dados) {
    const response = await fetch(`${API_URL}/tabelas-peso/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...authHeader() },
      body: JSON.stringify(dados)
    });
    return checarResposta(response, 'Erro ao atualizar tabela');
  },

  async remover(id) {
    const response = await fetch(`${API_URL}/tabelas-peso/${id}`, {
      method: 'DELETE',
      headers: { ...authHeader() },
    });
    return checarResposta(response, 'Erro ao remover tabela');
  },

  // Envia uma imagem para o Backend processar com IA (Gemini Vision)
  // Aceita qualquer imagem de tabela de pesos — não restrito a um único modelo
  async extrairIA(imageFile) {
    const formData = new FormData();
    formData.append('imagem', imageFile);

    const response = await fetch(`${API_URL}/tabelas-peso/extrair-ia`, {
      method: 'POST',
      headers: { ...authHeader() },
      body: formData
    });

    const data = await response.json();

    captureRefreshedToken(response.headers);
    if (response.status === 401) {
      handleUnauthorized();
    }
    if (!response.ok) {
      const errMsg = data.error || 'Erro ao processar imagem com IA';
      const instrucoes = data.instrucoes ? `\n${data.instrucoes}` : '';
      throw new Error(errMsg + instrucoes);
    }

    return data; // { colunas: [], linhas: [], matriz: {} }
  }
};

